import React from 'react';
import { cn } from '../../lib/utils';

const WorkflowFoldersToggleButton = ({
  collapsed,
  onToggle,
  className,
}) => (
  <button
    type="button"
    className={cn(
      'workflow-folder-sidebar-toggle inline-grid h-[38px] w-[42px] place-items-center rounded-[11px]',
      'border border-white/14 bg-white/[0.035] text-zinc-200',
      'transition-[background,border,transform] duration-150',
      'hover:bg-white/[0.08] active:scale-[0.96]',
      className,
    )}
    aria-expanded={!collapsed}
    aria-controls="workflow-folders-sidebar"
    title={collapsed ? 'Expand folders' : 'Collapse folders'}
    data-testid="workflow-folder-sidebar-toggle"
    onClick={onToggle}
  >
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="4" y="5" width="16" height="14" rx="3" stroke="currentColor" strokeWidth="1.8" />
      <path d="M10 5v14" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  </button>
);

export default WorkflowFoldersToggleButton;
